import {observer} from 'mobx-react';
import {Panel} from 'shared/components';
import EmployeeProfileContainer from '../../EmployeeProfileContainer';
import ReviewsTable from './ReviewsTable';
import GoalsTable from './GoalsTable';
import CheckinsTable from './CheckinsTable';

const PerformanceContainer = observer(({uiState}) => {
  const {scope, employee} = uiState;

  return (
    <EmployeeProfileContainer uiState={uiState}>
      <Panel.Stack loose>
        {scope.reviews && <ReviewsTable employee={employee}/>}
        {scope.goals && <GoalsTable employee={employee}/>}
        {scope.checkins && <CheckinsTable employee={employee}/>}
      </Panel.Stack>
    </EmployeeProfileContainer>
  );
});

export default PerformanceContainer;
